import {connect} from "react-redux";
import PJPView from "./View";
import {bindActionCreators} from "redux";
import {pjpDetailsById} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    PJPDetailsByD:state.FasttagToll.PJPDetailsByD,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pjpDetailsById,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PJPView);
